import { c as _c } from "react/compiler-runtime";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useRefreshSeatUsage } from "@components/table/members/assign-seats/use-refresh-seat-usage";
import { setMemberPermissionsInCompany } from "@store/members/members-slice-thunk";
import { useAppDispatch } from "@store/store-helper";
/** Returns how to give a member a SCENE seat or take it away again */
export function useSceneSeatPermission() {
  const $ = _c(6);
  const dispatch = useAppDispatch();
  const companyId = useCompanyId();
  const refreshSeatUsage = useRefreshSeatUsage();
  let t0;
  if ($[0] !== companyId || $[1] !== dispatch) {
    t0 = async function setSceneSeatPermission(member, isAllowed) {
      await dispatch(setMemberPermissionsInCompany({
        companyId,
        userIdentity: member.identity,
        permissions: [{
          name: "sceneSeat",
          allowed: isAllowed
        }]
      })).unwrap();
    };
    $[0] = companyId;
    $[1] = dispatch;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const setSceneSeatPermission = t0;
  let t1;
  if ($[3] !== refreshSeatUsage || $[4] !== setSceneSeatPermission) {
    t1 = {
      setSceneSeatPermission,
      refreshSeatUsage
    };
    $[3] = refreshSeatUsage;
    $[4] = setSceneSeatPermission;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}